import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiUrls, Doctypes } from '../../shared/apiurls';
import { Router } from '@angular/router';
import {
  LOCAL_STORAGE_KEYS,
  LocalStorageItemsService,
} from '../../services/local-storage-items.service';
import { ToastrService } from 'ngx-toastr';
import {
  NgbModal,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import Sortable from 'sortablejs';
import { HospitalityService } from '../../services/hospitality.service';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbNavModule, NgbTooltipModule],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
})
export class ProductsComponent {
  // @ViewChild('scrollContainer', { static: true })
  // scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('moreSolutionsWrapper') moreSolutions!: ElementRef;
  @ViewChild('col3Bottom') col3Bottom!: ElementRef;
  // @ViewChild('moreSolutions') moreSolutions!: ElementRef;
  @ViewChild('parentScroll', { read: ElementRef }) parentScroll!: ElementRef;
  @ViewChild('cardsContainer') cardsContainer!: ElementRef;
  @ViewChild('restrictedSection') restrictedSection!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  sortableCreated = false;
  @ViewChild('fileInp2') fileInp2!: HTMLInputElement;
  cards: any = [];
  isDisabled: boolean = true;
  logoUrl: string = '';
  active = 1;
  products_list: any = [];
  MarshCode: any;
  selectedCompany: any = '';
  selectedMarshaData: any = null;
  employee_details: any = {};
  modalRef: any;
  previewImage: string | ArrayBuffer | null = null;
  editingProduct: any = null;
  isNotificationOpen = true;
  companyTitle: any;
  custom_company: any;
  data_count: any;
  subscribed_list: any = [];
  restrictedlist: any = [];
  notsubscribed_list: any = [];
  product_status: any;
  activeTab: string = 'home';
  showScrollBtn = false;
  restrictedOverflow = false;
  showMoreSolutions = false;
  activeSection: string = 'restricted';
  cardColors: string[] = [
    '#D1F4FA',
    '#FFDDE5',
    '#D9D9D9',
    '#FFE9FA',
    '#E3E3E3',
    '#EDFFE9',
    '#DEDEF3',
    '#EAB6F6',
    '#FFFFEE',
    '#FFFCE5',
    '#C8DDE0',
    '#BAFFAC',
  ];
  cardColors1: string[] = [
    '#E3E3E3',
    '#EDFFE9',
    '#DEDEF3',
    '#EAB6F6',
    '#FFFFEE',
    '#FFFCE5',
    '#C8DDE0',
    '#BAFFAC',
  ];
  cardColors2: string[] = ['#FFFFEE', '#FFFCE5', '#C8DDE0', '#BAFFAC'];

  bgImages: string[] = [
    '../../../assets/images/bg-1.jpg',
    '../../../assets/images/bg-2.jpg',
    '../../../assets/images/bg-3.jpg',
  ];

  isHeaderExpanded: boolean = true;
  private observer!: IntersectionObserver;
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private localStorageService: LocalStorageItemsService,
    private modalService: NgbModal,
    private hospitalityService: HospitalityService,
  ) {
    this.localStorageService
      .getItem$(LOCAL_STORAGE_KEYS.LOGIN)
      .subscribe((data) => {
        this.employee_details = data;
      });

    this.hospitalityService.headerExpanded$.subscribe((val) => {
      this.isHeaderExpanded = val;
    });

    this.hospitalityService.marshaData$.subscribe((data) => {
      if (!data) return;
      this.MarshCode = data.marshaCode;
      let modules = data?.marshaDetails?.module_details;
      this.selectedMarshaData = modules.filter((item: any) => item.enable == 1);
      this.selectedCompany = `${data.marshaCode} | ${data?.marshaDetails?.hospitality_unit_name}`;
      const fullName = data?.marshaDetails?.hospitality_unit_name || '';
      this.custom_company = fullName.split(' ').slice(0, 2).join(' ');
      this.get_module_list();
    });
  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.toggleNotification()
    // }, 5000);
    const saved = localStorage.getItem('marsha_sorted_order');

    if (saved) {
      this.selectedMarshaData = JSON.parse(saved);
    }
  }

  // toggleNotification() {
  //   this.isNotificationOpen = !this.isNotificationOpen;
  // }

  activeButtonmenu = '';
  activeButton = 'subscribed';
  filterToggleMenu(app: any) {
    this.activeButtonmenu = app;
  }

  navigate_module(product: any) {
    if (product?.enable === 0) {
      this.toastr.error('Module not subscribed');
      return;
    }
    if (
      this.employee_details?.designation === 'Caratred Supervisor' ||
      this.employee_details?.company_field === 'CRT'
    ) {
      this.localStorageService.setItem(
        LOCAL_STORAGE_KEYS.SELECTED_COMPANY,
        product,
      );
    }
    window.open(window.location.origin + product?.route, '_blank');
  }
 
  openmodule(companyview: any, title: any, status: any) {
    this.companyTitle = title;
    this.product_status = status;
    this.modalService.open(companyview, {
      size: 'lg',
      centered: true,
    });
  }

  ngAfterViewChecked(): void {
    if (!this.sortableCreated && this.cardsContainer) {
      this.initSortable();
      this.sortableCreated = true;
    }
  }

  initSortable() {
    Sortable.create(this.cardsContainer.nativeElement, {
      animation: 150,
      handle: '.menu-bar',
      ghostClass: 'sortable-ghost',

      onEnd: (event: any) => {
        const oldIndex = event.oldIndex;
        const newIndex = event.newIndex;
        const moved = this.subscribed_list.splice(oldIndex, 1)[0];
        this.subscribed_list.splice(newIndex, 0, moved);
        this.saveLocalOrder();
      },
    });
  }

  saveLocalOrder() {
    const order = this.subscribed_list.map((item: any) => item.module);
    const key = `module_order_${this.MarshCode}_${this.employee_details.designation}`;
    // console.log("Saving key:", key, order);
    localStorage.setItem(key, JSON.stringify(order));
  }

  get_module_list() {
    const key = `module_order_${this.MarshCode}_${this.employee_details.designation}`;
    this.http
      .get(ApiUrls.get_module_list, {
        params: {
          marsha_code: this.MarshCode,
          // role: this.employee_details.designation,
        },
      })
      .subscribe((res: any) => {
        const data = res?.message?.data;
        if (!data) return;
        let list = data.subscribed || [];
        // this.localStorageService.startTimerToCheckTimeOut();
        const savedOrder = JSON.parse(localStorage.getItem(key) || '[]');
        if (savedOrder.length > 0) {
          const ordered: any[] = [];
          const remaining: any[] = [];
          list.forEach((item: any) => {
            const index = savedOrder.indexOf(item.module);
            if (index !== -1) ordered[index] = item;
            else remaining.push(item);
          });
          list = [...ordered.filter(Boolean), ...remaining];
        }

        this.subscribed_list = [...list];
        this.restrictedlist = data.restricted_for_your_role || [];
        this.notsubscribed_list = data.not_subscribed || [];
        this.data_count =
          this.subscribed_list.length + this.restrictedlist.length;
      });
  }

  scrollToBottom() {
    this.showMoreSolutions = true;
    setTimeout(() => {
      this.moreSolutions.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      window.scrollBy(0, -100);
    }, 2);
  }
  onScroll() {
    const container = this.scrollContainer.nativeElement;
    const moreSol = this.moreSolutions?.nativeElement;
    if (!moreSol) {
      this.showScrollBtn = false;
      return;
    }
    const containerBottom = container.scrollTop + container.clientHeight;
    const moreSolutionsTop = moreSol.offsetTop;

    //  Show button ONLY while user is above "More solutions"
    this.showScrollBtn = containerBottom < moreSolutionsTop;
  }
  // ngAfterViewInit() {
  //   this.showScrollBtn = this.subscribed_list?.length < 9;
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       this.showScrollBtn =
  //         !entry.isIntersecting && this.subscribed_list?.length < 9;
  //     },
  //     {
  //       root: null,
  //       threshold: 0.05,
  //     },
  //   );

  //   observer.observe(this.moreSolutions.nativeElement);
  // }
  getInitials(name: string): string {
    if (!name) return '';

    const bySpace = name.trim().split(/\s+/);
    if (bySpace.length >= 2) {
      return bySpace
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('');
    }

    const byCase = name.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
    if (byCase.length >= 2) {
      return byCase
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('');
    }

    return name.slice(0, 2).toUpperCase();
  }
   getAvatarColor(
    name: string,
    type: 'subscribed' | 'restricted' | 'notsubscribed' = 'subscribed',
  ): string {
    const colorMap = {
      subscribed: [
        '#4f46e5',
        '#0891b2',
        '#059669',
        '#d97706',
        '#dc2626',
        '#7c3aed',
        '#db2777',
        '#65a30d',
        '#ea580c',
        '#0284c7',
        '#9333ea',
        '#16a34a',
      ],
      restricted: [
        '#f97316',
        '#06b6d4',
        '#8b5cf6',
        '#10b981',
        '#f43f5e',
        '#3b82f6',
        '#eab308',
        '#ec4899',
        '#14b8a6',
        '#a855f7',
        '#22c55e',
        '#ef4444',
      ],
      notsubscribed: [
        '#fb923c',
        '#22d3ee',
        '#a78bfa',
        '#34d399',
        '#fb7185',
        '#60a5fa',
        '#facc15',
        '#f472b6',
        '#2dd4bf',
        '#c084fc',
        '#4ade80',
        '#f87171',
      ],
    };

    const colors = colorMap[type];
    const index =
      (name || '')
        .split('')
        .reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;

    return colors[index];
  }
}
